import { billOfMaterialsIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const bulkDeleteBillOfMaterials = {
  name: "bulkDeleteBillOfMaterials" as const,
  input: z.object({
    billOfMaterialsIds: z.array(billOfMaterialsIdFormat.schema),
  }),
  output: z.object({ success: z.boolean() }),
};
